// 🧿 طلسم محافظ فایل

// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Requests
import { getTradeTable } from "src/Requests/automaticMarketMaking";
// Types
import {
  ITradeTableSearchParams,
  ITradeTableReport,
} from "src/Interfaces/automaticMarketMaking";

interface TradeTableProps {
  searchParam: ITradeTableSearchParams;
}

const TradeTable = ({ searchParam }: TradeTableProps) => {
  return (
    <div className="overflow-auto order-table w-full">
      <TableTemplate<ITradeTableSearchParams, ITradeTableReport>
        refreshTableTime={5000}
        getDataTable={getTradeTable}
        withSort
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            setSortingType={setSortingType}
            sortingType={sortingType}
            tableBoxClassName="max-h-[300px]"
          />
        )}
        searchParameters={searchParam}
      />
    </div>
  );
};

export default TradeTable;
